import React, { Component } from "react";
import { Form, FormGroup, FormControl, Glyphicon, Tooltip, OverlayTrigger, Col, Alert } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import config from '../config';

export default class Contact extends Component {
  constructor(props) {
  	super(props);
  	this.state = {
  	  isLoading: false,
  	  name: '',
  	  phone: '',
  	  email: '',
      message: '',
      alertMessage: '',
      isErrorMessage: false
  	};
  }
  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }
  validate() {
    var errors = [];
    if (this.state.name.length < 3) {
      errors.push('Debe ingresar un nombre válido');
    }
    if (this.state.email.length < 8) {
      errors.push('Debe ingresar un email válido');
    }
    if (this.state.phone.length < 8) {
      errors.push('Debe ingresar un teléfono válido');
    }
    if (this.state.message.length < 3) {
      errors.push('Debe ingresar el mensaje');
    }
    return errors;
  }
  handleSubmit = async event => {
    event.preventDefault();
    const errors = this.validate();
    if (errors.length) {
      this.setState({ alertMessage: errors.join('<br>'), isErrorMessage: true });
      return;
    }
    this.setState({ isLoading: true });
    try {
  	  const response = await this.contactSupport({
        ...this.props.fields,
  	    name: this.state.name,
        email: this.state.email,
        phone: this.state.phone,
        message: this.state.message
      });
      console.log(response);
      this.setState({ isLoading: false, alertMessage: 'Hemos recibido tu mensaje, pronto nos comunicaremos contigo.', isErrorMessage: false, name: '', email: '', phone: '', message: '' });
    } catch (e) {
      console.error(e);
      this.setState({ isLoading: false, alertMessage: 'Error al enviar mensaje. Favor intenta nuevamente', isErrorMessage: true });
    }
  }
  async contactSupport(contact) {
    const result = await fetch(config.apiGateway.URL + '/contact', {
      method: 'POST',
      headers: { 'content-type': 'application/json'},
      body: JSON.stringify(contact)
    });
    if (result.status !== 200) {
      this.setState({ alertMessage: 'Error al enviar mensaje. Intenta nuevamente.', isErrorMessage: true });
    }
  }
  render() {
    return (
      <div>
        <h2>Cont&aacute;ctanos</h2>

          <Form horizontal onSubmit={this.handleSubmit}>
            <FormGroup controlId="name">
              <Col sm={10}>
                <FormControl componentClass="input" onChange={this.handleChange} value={this.state.name} placeholder="Nombre completo" />
              </Col>
              <Col sm={2}>
                <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Ingrese su nombre.</Tooltip>} placement="left">
                  <a className="info" tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
                </OverlayTrigger>
              </Col>
            </FormGroup>
            <FormGroup controlId="email">
              <Col sm={10}>
                <FormControl componentClass="input" onChange={this.handleChange} value={this.state.email} placeholder="Email" />
              </Col>
              <Col sm={2}>
                <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Ingrese su e-mail.</Tooltip>} placement="left">
                  <a className="info" tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
                </OverlayTrigger>
              </Col>
            </FormGroup>
            <FormGroup controlId="phone">
              <Col sm={10}>
                <FormControl componentClass="input" onChange={this.handleChange} value={this.state.phone} placeholder="Teléfono" />
              </Col>
              <Col sm={2}>
                <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Ingrese su teléfono.</Tooltip>} placement="left">
                  <a className="info" tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
                </OverlayTrigger>
              </Col>
            </FormGroup>
            <FormGroup controlId="message">
              <Col sm={10}>
                <FormControl
                  componentClass="textarea"
                  onChange={this.handleChange}
                  value={this.state.message}
                  placeholder="Mensaje"
                />
              </Col>
              <Col sm={2}>
                <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Ingrese su mensaje lo más claro posible.</Tooltip>} placement="left">
                  <a className="info" tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
                </OverlayTrigger>
              </Col>
            </FormGroup>
            { this.state.alertMessage && this.state.isErrorMessage  && <Alert bsStyle="danger" ><div dangerouslySetInnerHTML={{__html: this.state.alertMessage}}/></Alert> }
            { this.state.alertMessage && !this.state.isErrorMessage  && <Alert bsStyle="success" ><div dangerouslySetInnerHTML={{__html: this.state.alertMessage}}/></Alert> }
            <FormGroup controlId="buttons" className="align-center">
              <Col sm={10}>
                <LoaderButton
                      bsStyle="primary"
                      bsSize="large"
                      type="submit"
                      isLoading={this.state.isLoading}
                      text="Enviar"
                      loadingText="Enviando…" />
              </Col>
              <Col sm={2}></Col>
            </FormGroup>
          </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ContactForm.js